import React from "react";

export const AuthLoading = (): JSX.Element => {
	return (
		<p>authentication in progress</p>
	);
};
